import { render, staticRenderFns } from "./tip-dot.vue?vue&type=template&id=1d085c81&scoped=true&"
import script from "./tip-dot.vue?vue&type=script&lang=js&"
export * from "./tip-dot.vue?vue&type=script&lang=js&"
import style0 from "./tip-dot.vue?vue&type=style&index=0&id=1d085c81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d085c81",
  null
  
)

export default component.exports